import React from 'react'
import { HTMLContainer, ShapeUtil, TLBaseShape, Rectangle2d } from '@bigbluebutton/tldraw'
import { ReactNode } from 'react'

// Define the Graph Grid Shape type
type GraphGridShape = TLBaseShape<'graphgrid', { w: number; h: number; rows: number; cols: number }> & {
  x: number;  // Position on the x-axis
  y: number;  // Position on the y-axis
  rotation: number; // Rotation of the shape
  index: number;  // Index for stacking order
}

export class GraphGridShapeUtil extends ShapeUtil<GraphGridShape> {
  static override type = 'graphgrid' as const

  // Define the default properties for the grid shape
  getDefaultProps(): GraphGridShape['props'] {
    return {
      w: 150,      // Default width of the entire grid
      h: 150,      // Default height of the entire grid
      rows: 5,     // Default number of rows
      cols: 5,     // Default number of columns
    }
  }

  // Define the geometry for the shape (optional)
  getGeometry(shape: GraphGridShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
    })
  }

  // Define the component rendered for the grid shape
  component(shape: GraphGridShape): ReactNode {
    const { w, h, rows, cols } = shape.props
    const cellWidth = w / cols  // Width of each cell
    const cellHeight = h / rows // Height of each cell

    return (
      <HTMLContainer>
        <svg id="mySvg" width={w} height={h}>
          <defs>
            {/* Adjust the grid pattern based on cell size */}
            <pattern
              id="tenthGrid"
              width={cellWidth}
              height={cellHeight}
              patternUnits="userSpaceOnUse"
            >
              <path
                id="tgPath"
                d={`M ${cellWidth} 0 L 0 0 0 ${cellHeight}`}
                fill="none"
                stroke="silver"
                strokeWidth="0.5"
              />
            </pattern>
            <pattern
              id="grid"
              width={cellWidth}
              height={cellHeight}
              patternUnits="userSpaceOnUse"
            >
              <rect
                id="grRect"
                width={cellWidth}
                height={cellHeight}
                fill="url(#tenthGrid)"
              />
              <path
                id="grPath"
                d={`M ${cellWidth} 0 L 0 0 0 ${cellHeight}`}
                fill="none"
                stroke="gray"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <g>
            <marker
              id="shapeId"
              orient="auto"
              markerWidth="2"
              markerHeight="4"
              refX="1.3"
              refY="2"
            >
              <path d="M0,0 V4 L2,2 Z" fill="#000" />
            </marker>
            <marker
              id="startShapeId"
              orient="auto-start-reverse"
              markerWidth="2"
              markerHeight="4"
              refX="1.3"
              refY="2"
            >
              <path d="M0,0 V4 L2,2 Z" fill="#000" />
            </marker>
          </g>
          <g>
            <rect width="100%" height="100%" fill="lightblue" />  {/* Light blue background */}
            <rect width="100%" height="100%" fill="url(#grid)" />

            {/* X Axis Line - GreenBlue */}
            <line
              id="lineVertical"
              x1={w / 2}
              y1="3"
              x2={w / 2}
              y2={h - 3}
              stroke="#00BCD4"
              strokeWidth="2"
              markerEnd="url(#shapeId)"
              markerStart="url(#startShapeId)"
            />

            {/* Y Axis Line - GreenBlue */}
            <line
              id="lineHorizontal"
              x1="3"
              y1={h / 2}
              x2={w - 3}
              y2={h / 2}
              stroke="#00BCD4"
              strokeWidth="2"
              markerEnd="url(#shapeId)"
              markerStart="url(#startShapeId)"
            />

            {/* Axis Labels and Coordinates */}
            <text fontSize="12" x={w / 2 - 10} y={h / 2 + 12} fill="red">
              0
            </text>
            <text fontSize="12" x="30" y="30" fill="red">
              Y Label
            </text>
            <text fontSize="12" x={w - 50} y={h / 2 + 10} fill="red">
              X Label
            </text>
            <text fontSize="12" x={w / 2 + 10} y={h / 2 - 20} fill="red">
              X Coordinate
            </text>
            <text fontSize="12" x={w / 2 + 10} y={h / 2 + 30} fill="red">
              -X Coordinate
            </text>
            <text fontSize="12" x={w / 2 - 30} y={h / 2 - 10} fill="red">
              Y Coordinate
            </text>
            <text fontSize="12" x={w / 2 - 30} y={h / 2 + 30} fill="red">
              -Y Coordinate
            </text>
          </g>
        </svg>
        {/* <svg id="mySvg" width={w} height={h}>
          <defs>
            <pattern id="tenthGrid" width={w / 10} height={h / 10} patternUnits="userSpaceOnUse">
              <path d={`M ${w / 10} 0 L 0 0 0 ${h / 10}`} fill="none" stroke="#666" strokeWidth="0.5" />
            </pattern>
            <pattern id="grid" width={w / cols} height={h / rows} patternUnits="userSpaceOnUse">
              <rect width={w / cols} height={h / rows} fill="url(#tenthGrid)" />
              <path d={`M ${w / cols} 0 L 0 0 0 ${h / rows}`} fill="none" stroke="gray" strokeWidth="1" />
            </pattern>
          </defs>
          <g>
            <marker id="shapeId" orient="auto" markerWidth="2" markerHeight="4" refX="1.3" refY="2">
              <path d="M0,0 V4 L2,2 Z" fill="#000" />
            </marker>
            <marker id="startShapeId" orient="auto-start-reverse" markerWidth="2" markerHeight="4" refX="1.3" refY="2">
              <path d="M0,0 V4 L2,2 Z" fill="#000" />
            </marker>
          </g>
          <g>
            <rect width="100%" height="100%" fill="#bbb" />
            <rect width="100%" height="100%" fill="url(#grid)" />
            <line x1={w / 2} y1="3" x2={w / 2} y2={h - 3} stroke="greenblue" strokeWidth="2" markerEnd="url(#shapeId)" markerStart="url(#startShapeId)" />
            <line x1="3" y1={h / 2} x2={w - 3} y2={h / 2} stroke="greenblue" strokeWidth="2" markerEnd="url(#shapeId)" markerStart="url(#startShapeId)" />
            <text fontSize="12" x={w / 2 - 10} y={h / 2 + 12} fill="red">0</text>
            <text fontSize="12" x="30" y="30" fill="red">Y Label</text>
            <text fontSize="12" x={w - 30} y={h / 2} fill="red">X Label</text>
            <text fontSize="12" x={w / 2 + 10} y={h / 2 - 20} fill="red">X Coordinate</text>
            <text fontSize="12" x={w / 2 - 30} y={h / 2 + 30} fill="red">-X Coordinate</text>
            <text fontSize="12" x={w / 2 - 40} y={h / 2 - 30} fill="red">Y Coordinate</text>
            <text fontSize="12" x={w / 2 - 40} y={h / 2 + 50} fill="red">-Y Coordinate</text>
          </g>
        </svg> */}
      </HTMLContainer>
    )
  }
  // Enable resizing
  isAspectRatioLocked = () => false; // Allow free resizing
  canResize = () => true; // Enable resize handles

  onResize = (shape: GraphGridShape, newSize: { initialBounds: { w: number; h: number }; scaleX: number; scaleY: number }) => {
    return {
      ...shape,
      props: {
        ...shape.props,
        w: newSize.initialBounds.w * newSize.scaleX, // ✅ Scale width
        h: newSize.initialBounds.h * newSize.scaleY, // ✅ Scale height
        rows: shape.props.rows ?? 4,   // Prevent undefined rows
        cols: shape.props.cols ?? 5,   // Prevent undefined cols
      },
    };
  };

  // Define the indicator for the grid shape (what is shown in selection)
  indicator(shape: GraphGridShape) {
    return <rect width={shape.props.w} height={shape.props.h} />
  }
}
